import { FetchResult, gql } from 'apollo-boost';
import { MultiError } from '../../../types/multi-error';
import { graphqlClient } from '../../graphql-client';

const MUTATION = gql`
    mutation UserGroupUserRemove($userGroupUid: String!, $userUid: String!){
        user_group_user_remove (user_group_uid: $userGroupUid, user_uid: $userUid) {
            success,
        }
    }
`;

export async function removeUserFromUserGroup(userGroupUid: string, userUid: string): Promise<{ success: boolean }> {
    const result: FetchResult<{ user_group_user_remove: { success: boolean } }> = await graphqlClient.mutate({
        mutation: MUTATION,
        variables: { userGroupUid, userUid },
        errorPolicy: 'all',
    });

    if(!result.data || result.errors && result.errors.length) {
        throw new MultiError(result.errors || ['Unknown error']);
    }

    return result.data.user_group_user_remove;
}
